import api from "../utils/api";

export const investorsService = {
  // Fetch investors with pagination and filters
  async fetchInvestors(params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    const response = await api.get(`/api/investors?${queryParams}`);
    return response.data;
  },

  // Fetch investor stats
  async fetchInvestorStats(params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    const response = await api.get(`/api/investors/stats?${queryParams}`);
    return response.data;
  },

  // Create investor
  async createInvestor(data) {
    const response = await api.post("/api/investors", data);
    return response.data;
  },

  // Update investor
  async updateInvestor(id, data) {
    const response = await api.put(`/api/investors/${id}`, data);
    return response.data;
  },

  // Hard delete investor (permanent)
  async deleteInvestor(id) {
    const response = await api.delete(`/api/investors/${id}`);
    return response.data;
  },

  // Soft delete investor (move to deleted records)
  async softDeleteInvestor(id, deleteReason = null) {
    const response = await api.post(`/api/investors/${id}/soft-delete`, {
      deleteReason,
    });
    return response.data;
  },

  // Fetch deleted investors
  async fetchDeletedInvestors(params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    const response = await api.get(
      `/api/investors/deleted/records?${queryParams}`
    );
    return response.data;
  },

  // Restore deleted investor
  async restoreInvestor(historyId) {
    const response = await api.post(
      `/api/investors/deleted/${historyId}/restore`
    );
    return response.data;
  },

  // Permanently delete investor from history
  async permanentlyDeleteInvestor(historyId) {
    const response = await api.delete(
      `/api/investors/deleted/${historyId}/permanent`
    );
    return response.data;
  },

  // Get investor count by scheme (for bulk delete preview)
  async getInvestorCountByScheme(schemeId) {
    const response = await api.get(`/api/investors/bulk/count/${schemeId}`);
    return response.data;
  },

  // Bulk delete investors by scheme
  async bulkDeleteByScheme(schemeId, deleteType, deleteReason = null) {
    const response = await api.post("/api/investors/bulk/delete-by-scheme", {
      scheme_id: schemeId,
      delete_type: deleteType,
      delete_reason: deleteReason,
    });
    return response.data;
  },

  // Fetch schemes
  async fetchSchemes() {
    const response = await api.get("/api/schemes");
    return response.data;
  },

  // Dashboard stats
  async fetchDashboardStats() {
    const response = await api.get("/api/investors/dashboard/stats");
    return response.data;
  },

  // Recent investors
  async fetchRecentInvestors() {
    const response = await api.get("/api/investors/dashboard/recent");
    return response.data;
  },
};

export default investorsService;
